const firebaseConfig = {
    apiKey: "AIzaSyBOrDpLRJNrsiguNf4MFEKlE9wY0XVqrAs",
    authDomain: "web-developing-b5f29.firebaseapp.com",
    projectId: "web-developing-b5f29",
    storageBucket: "web-developing-b5f29.appspot.com",
    messagingSenderId: "95583315236",
    appId: "1:95583315236:web:7a7cd8498f3688c7f63fb1"
};
export default firebaseConfig;